import * as Yup from 'yup'

export const validation = {
    precio_hora: Yup.string().required('El precio mensual del alumno es obligatorio.'),
}

export const validationSchema = Yup.object().shape(validation)